<template>
    <span class="select-none focus:outline-none">
        <span
            class="w-full cursor-pointer"
            ref="triggerContainer"
            @click="openDropdown($event)"
        >
            <slot name="button"></slot>
        </span>
    </span>

    <teleport to="body" v-if="showDropdown">
        <div
            ref="dropdownContainer"
            class="fixed left-0 right-0 top-0 z-40 flex h-full items-center justify-center bg-black/10"
            @click.self="closeDropdown()"
        ></div>
        <div
            :class="'z-50' + ' ' + cssClasses"
            :style="'width:' + dropdownWidth + 'px; ' + positionStyles"
        >
            <slot name="content"></slot>
        </div>
    </teleport>
</template>

<script>
export default {
    name: "Dropdown",
    props: {
        enabled: {
            type: Boolean,
            default: true,
        },
        cssClasses: {
            type: String,
            default:
                "shadow-loose absolute rounded border border-neutral-10 bg-white text-black text-left",
        },
        openFrom: {
            type: String,
            default: "left",
        },
        pxWidth: {
            type: [Number, String],
            default: 0,
        },
        autoWidth: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showDropdown: false,
            positionStyles: "left:0px;top:0px",
            dropdownWidth: this.pxWidth ?? null,
        };
    },
    methods: {
        openDropdown($event) {
            if (!this.enabled) {
                return;
            }

            this.calculatePositionCss();

            // if (!this.autoWidth) {
            //     dropdownWidth =
            //         this.pxWidth !== 0 ? this.pxWidth : triggerWidth;
            //
            //     this.positionStyles =
            //         "left:" + leftPosPer + "%; top:" + topPosPer + "%;";
            // } else {
            //     switch (this.openFrom) {
            //         case "left":
            //             this.positionStyles += "left:0px;";
            //             break;
            //         case "right":
            //             this.positionStyles += "right:0px;";
            //             break;
            //     }
            // }

            this.showDropdown = true;
        },
        calculatePositionCss() {
            let bodyRect = document.body.getBoundingClientRect();
            let targetRect =
                this.$refs.triggerContainer.getBoundingClientRect();

            let dropdownWidth = parseInt(this.dropdownWidth);
            let triggerWidth = targetRect.width;

            let leftPosPx = targetRect.x;
            let topPosPx = targetRect.y + targetRect.height;

            let rightDropdownEdgePx = leftPosPx + dropdownWidth;

            if (rightDropdownEdgePx + 12 > bodyRect.width) {
                leftPosPx = bodyRect.width - dropdownWidth - 12;
            }

            this.positionStyles =
                "left:" + leftPosPx + "px; top:" + topPosPx + "px;";

            return;
        },
        closeDropdown() {
            this.showDropdown = false;
        },
    },
    mounted() {
        let vm = this;

        window.addEventListener("resize", vm.calculatePositionCss);
    },
    unmounted() {
        let vm = this;
        window.removeEventListener("resize", vm.calculatePositionCss);
    },
};
</script>

<style scoped></style>
